import React from 'react';
import { DatePicker, Typography } from 'antd';
import { primaryShades } from '../../../theme/theme';

const { Text } = Typography;

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;

const SingleDatePicker = ({
    label,
    value,
    onChange,
    placeholder = "Select date",
    format = "DD/MM/YYYY",
    style = {}
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
            ...style
        }}>
            {label && (
                <Text style={{
                    marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                    color: PRIMARY_700,
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)'
                }}>
                    {label}
                </Text>
            )}
            <DatePicker
                value={value}
                onChange={onChange}
                format={format}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    height: 'clamp(2rem, 5vw, 2.25rem)',
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 0.75rem)'
                }}
                popupStyle={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)'
                }}
            />
        </div>
    );
};

export default SingleDatePicker; 